'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:ModalManagedLicenseSummaryDetailsCtrl
 * @description
 * # ModalManagedLicenseSummaryDetailsCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
  .controller('ModalManagedLicenseSummaryDetailsCtrl', function ($scope, $uibModalInstance, licenseSummary) {
      // Passed from MyLicensesCtrl when opening modal
      $scope.license = licenseSummary;

      /**
       * Delegates to MyLicensesCtrl's changeBillingPeriod (shared scope). On success we close this modal as well:
       * the renewal price and dates shown here are now stale, and the list behind us has already been updated.
       */
      $scope.changeBillingPeriodAndClose = function () {
          $scope.changeBillingPeriod(licenseSummary).then(function (changedLicense) {
              if (changedLicense) {
                  $uibModalInstance.close();
              }
          });
      };


      $scope.objectSize = function(obj) {
        return obj ? Object.keys(obj).length : 0;
      };

      // Helper to get cart items in a display-friendly order (root first, then by date)
      $scope.getOrderedCartItems = function(cartItemsById, rootCartItemId) {
          let itemsArray = Object.values(cartItemsById);

          return itemsArray.sort(function(a, b) {
              if (a.id === rootCartItemId) {
				  return -1;
			  } // Root item first
              if (b.id === rootCartItemId) {
				  return 1;
			  }  // Root item first
              return (a.cart.created) - (b.cart.created); // Then by date
          });
      };
  });
